var _circle, _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiSad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ab2719ff",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 8.01,
    y2: 9,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.99,
    y1: 9,
    x2: 16,
    y2: 9,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39,16.05a5,5,0,0,1,2.66-2.66,5.07,5.07,0,0,1,3.9,0,5,5,0,0,1,2.66,2.66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSad1);
export default __webpack_public_path__ + "static/media/emojiSad1.9b52981c0325081cad0b99a37d0e14c5.svg";
export { ForwardRef as ReactComponent };